import { Component } from '@angular/core';
import { E5coreUiWorkFieldTypeListBaseComponent } from './e5core-ui-work-field-type-list-base';

@Component({
  selector: 'e5core-ui-work-field-type-list-material',
  templateUrl: './e5core-ui-work-field-type-list-material.component.html',
  styleUrls: ['./e5core-ui-work-field-type-list-material.component.css']
})
export class E5coreUiWorkFieldTypeListMaterialComponent extends E5coreUiWorkFieldTypeListBaseComponent {
}
